import { MapObj } from '@types';

enum UserPermissionTypes {
  BRANCH_CREATE = 'branch_create',
  BRANCH_VIEW = 'branch_view',
  BRANCH_EDIT = 'branch_edit',
  BRANCH_DISABLE = 'branch_disable',
  GROUP_VIEW = 'group_view',
  GROUP_PAYMENT_SUMMARY_VIEW = 'group_payment_summary_view',
  GROUP_CREATE = 'group_create',
  GROUP_EDIT = 'group_edit',
  GROUP_DISABLE = 'group_disable',
  GROUP_MEMBER_CREATE = 'group_member_create',
  GROUP_MEMBER_EDIT = 'group_member_edit',
  GROUP_MEMBER_VIEW = 'group_member_view',
  GROUP_MEMBER_TAG_ASSIGN = 'group_member_tag_assign',
  ORG_ADMIN_CREATE = 'organisation_admin_create',
  ORG_ADMIN_EDIT = 'organisation_admin_edit',
  ORG_ADMIN_VIEW = 'organisation_admin_view',
  BRANCH_ADMIN_CREATE = 'branch_admin_create',
  BRANCH_ADMIN_EDIT = 'branch_admin_edit',
  BRANCH_ADMIN_VIEW = 'branch_admin_view',
  GROUP_ADMIN_CREATE = 'group_admin_create',
  GROUP_ADMIN_EDIT = 'group_admin_edit',
  GROUP_ADMIN_VIEW = 'group_admin_view',
  FINANCE_ADMIN_CREATE = 'finance_create',
  FINANCE_ADMIN_EDIT = 'finance_edit',
  FINANCE_ADMIN_VIEW = 'finance_view',
  OWNER_VIEW = 'owner_view',
  PAYMENT_ORDER_GENERATE_REPORT = 'payment_order_generate_report',
  PAYMENT_ORDER_GENERATE_RECEIPT = 'payment_order_generate_receipt',
  PAYMENT_ORDER_CREATE = 'payment_order_create',
  PAYMENT_ORDER_VIEW = 'payment_order_view',
  PAYMENT_ORDER_SEND_REMINDER = 'payment_order_send_reminder',
  PAYMENT_ORDER_EDIT = 'payment_order_edit',
  PAYMENT_ORDER_DISABLE = 'payment_order_disable',
  PAYMENT_ORDER_MARK_PAID = 'payment_order_mark_paid',
  PAYMENT_ORDER_SPLIT_ENABLE = 'payment_order_split_enable',
  PAYMENT_ORDER_CLOSE = 'payment_order_close',
  PAYMENT_ORDER_DISCOUNT_CREATE = 'payment_order_discount_create',
  ORGANIZATION_LIST_VIEW = 'organisation_list_view',
  ORGANIZATION_DETAILS_VIEW = 'organisation_details_view',
  ORGANIZATION_STATUS_CHANGE = 'organisation_status_change',
  KYC_DOCUMENT_VIEW = 'kyc_document_view',
  KYC_DOCUMENT_STATUS_CHANGE = 'kyc_document_status_change',
  GROUP_ATTENDANCE_VIEW = 'group_attendance_view',
  GROUP_ATTENDANCE_EDIT = 'group_attendance_edit',
  GROUP_ATTENDANCE_REPORT_DOWNLOAD = 'group_attendance_report_download',
  DASHBOARD_VIEW = 'dashboard_view',
  DASHBOARD_VIEW_SUMMARY = 'dashboard_view_summary',
  ORG_DASHBOARD_VIEW = 'org_dashboard_view',
  ACCOUNT_DETAILS_VIEW = 'account_details_view',
  ACCOUNT_DETAILS_SENSITIVE_DATA_VIEW = 'account_details_sensitive_data_view',
  BRANCH_SUMMARY_VIEW = 'branch_summary_view',
  SUBSCRIPTION_VIEW = 'subscription_view',
  SUBSCRIPTION_EDIT = 'subscription_edit',
  PAYMENT_ORDER_GENERATE_GST_REPORT = 'payment_order_generate_gst_report',
  PAYMENT_ORDER_GENERATE_CUSTOM_REPORT = 'payment_order_generate_custom_report',
  PAYMENT_ORDER_GENERATE_GROUP_CUSTOM_REPORT = 'payment_order_generate_group_custom_report',
  AUDIT_LOG_VIEW = 'audit_log_view',
  ATTENDANCE_MANAGER_CREATE = 'attendance_manager_create',
  ATTENDANCE_MANAGER_EDIT = 'attendance_manager_edit',
  ATTENDANCE_MANAGER_VIEW = 'attendance_manager_view',
  CUSTOMER_LIST_VIEW = 'organisation_customer_list_view',
  CUSTOMER_DETAILS_EDIT = 'organisation_config_edit',
  CUSTOMER_DETAILS_VIEW = 'organisation_config_view',
  ORGANISATION_SETTINGS_EDIT = 'organisation_settings_edit',
  BRANCH_MEMBER_CREATE = 'branch_member_create',
  BRANCH_MEMBER_EDIT = 'branch_member_edit',
  TEAM_MEMBER_NAME_EDIT = 'edit_team_member_names',
  BRANCH_MEMBER_VIEW = 'branch_member_view',
  BRANCH_MEMBER_DELETE = 'branch_member_delete',
  EVENT_CREATE = 'event_create',
  EVENT_EDIT = 'event_edit',
  EVENT_VIEW = 'event_view',
  EVENT_STATUS_CHANGE = 'event_status_change',
  EVENT_TICKET_STATUS_CHANGE = 'event_ticket_status_change',
  EVENT_ATTENDEE_VIEW = 'event_attendee_view',
  EVENT_ATTENDEE_LIST = 'event_attendee_list',
  EVENT_QR_ATTENDEE_CHECK_IN = 'event_qr_attendee_check_in',
  EVENT_QR_ATTENDEE_VIEW = 'event_qr_attendee_view',
  EVENT_BOOKING_ID_READ = 'event_booking_id_read',
  EVENT_MANAGER_EDIT = 'event_manager_edit',
  EVENT_MANAGER_CREATE = 'event_manager_create',
  EVENT_MANAGER_VIEW = 'event_manager_view',
  INTEGRATION_EDIT = 'integration_edit',
  MEMBER_CONTACT_VIEW = 'member_contact_view',
  PAYMENT_MANAGER_VIEW = 'payment_manager_view',
  PAYMENT_MANAGER_CREATE = 'payment_manager_create',
  PAYMENT_MANAGER_EDIT = 'payment_manager_edit',
  EVENT_BRANCH_VIEW = 'event_branch_view',
  EXPENSE_VIEW = 'expense_view',
  EXPENSE_CREATE = 'create_expense',
  EXPENSE_DELETE = 'expense_delete',
  EXPENSE_STATUS_CHANGE = 'expense_status_change',
  EVENT_VOLUNTEER_CREATE = 'event_volunteer_create',
  EVENT_VOLUNTEER_VIEW = 'event_volunteer_view',
  EVENT_VOLUNTEER_EDIT = 'event_volunteer_edit',
  FORM_VIEW = 'form_view',
  FORM_CREATE = 'form_create',
  FORM_EDIT = 'form_edit',
  FORM_STATUS_CHANGE = 'form_status_change',
  FORM_SUBMISSION_VIEW = 'form_submission_view',
  FORM_EXPORT = 'form_export',
  SALES_AGENT_CREATE = 'sales_agent_create',
  SALES_MANAGER_CREATE = 'sales_manager_create',
  SALES_AGENT_EDIT = 'sales_agent_edit',
  SALES_MANAGER_EDIT = 'sales_manager_edit',
  SALES_AGENT_VIEW = 'sales_agent_view',
  SALES_MANAGER_VIEW = 'sales_manager_view',
  LEAD_MANAGEMENT_CREATE = 'lead_create',
  LEAD_MANAGEMENT_VIEW = 'lead_view',
  LEAD_MANAGEMENT_EDIT = 'lead_edit',
  LEAD_REPORT_GENERATE = 'lead_report_generate',
  LEAD_BULK_UPLOAD = 'lead_bulk_upload',
  LEAD_MANAGEMENT_CONFIG_VIEW = 'lead_management_config_view',
  LEAD_MANAGEMENT_CONFIG_EDIT = 'lead_management_config_edit',
  ESIGN_VIEW = 'e_sign_view',
  ESIGN_CREATE = 'e_sign_create',
  SEND_ADMIN_INVITES = 'send_admin_invites',
  DELETE_ADMIN_INVITES = 'delete_admin_invites',
  VIEW_ADMIN_INVITES = 'view_admin_invites',
  SUCCESS_ALERT_EDIT = 'success_alert_edit',
  SUCCESS_ALERT_VIEW = 'success_alert_view',
  CSV_TEMPLATE_PROCESSOR = 'csv_template_processor'
}

export default UserPermissionTypes;

// Any team member role a user can manage grants access to team management
export const TEAM_MANAGEMENT_PERMISSIONS = [
  UserPermissionTypes.ORG_ADMIN_VIEW,
  UserPermissionTypes.OWNER_VIEW,
  UserPermissionTypes.BRANCH_ADMIN_VIEW,
  UserPermissionTypes.GROUP_ADMIN_VIEW,
  UserPermissionTypes.FINANCE_ADMIN_VIEW,
  UserPermissionTypes.PAYMENT_MANAGER_CREATE,
  UserPermissionTypes.PAYMENT_MANAGER_EDIT,
  UserPermissionTypes.EVENT_MANAGER_VIEW,
  UserPermissionTypes.EVENT_VOLUNTEER_VIEW,
  UserPermissionTypes.EVENT_VOLUNTEER_CREATE,
  UserPermissionTypes.EVENT_VOLUNTEER_EDIT,
  UserPermissionTypes.SALES_MANAGER_VIEW,
  UserPermissionTypes.SALES_AGENT_VIEW,
  UserPermissionTypes.ATTENDANCE_MANAGER_VIEW
];

// Page pathname & corresponding permission for page access
// By default, page will be accessible to all
export const pageMap: MapObj = {
  '/branches/add': [UserPermissionTypes.BRANCH_CREATE],
  '/branches/edit': [
    UserPermissionTypes.BRANCH_EDIT,
    UserPermissionTypes.ACCOUNT_DETAILS_VIEW
  ],
  '/branches/manage-bank-account': [UserPermissionTypes.ACCOUNT_DETAILS_VIEW],
  '/branches': [UserPermissionTypes.BRANCH_VIEW],
  '/groups': [UserPermissionTypes.GROUP_VIEW],
  '/team-management': TEAM_MANAGEMENT_PERMISSIONS,
  '/team-management/invite?role=organisation_admin': [
    UserPermissionTypes.ORG_ADMIN_CREATE
  ],
  '/team-management/invite?role=branch_admin': [
    UserPermissionTypes.BRANCH_ADMIN_CREATE
  ],
  '/team-management/invite?role=group_admin': [
    UserPermissionTypes.GROUP_ADMIN_CREATE
  ],
  '/team-management/invite?role=finance': [
    UserPermissionTypes.FINANCE_ADMIN_CREATE
  ],
  '/team-management/invite?role=attendance_manager': [
    UserPermissionTypes.ATTENDANCE_MANAGER_CREATE
  ],
  '/team-management/invite?role=sales_agent': [
    UserPermissionTypes.SALES_AGENT_CREATE
  ],
  '/team-management/invite?role=sales_manager': [
    UserPermissionTypes.SALES_MANAGER_CREATE
  ],
  '/organizations': [UserPermissionTypes.ORGANIZATION_LIST_VIEW],
  '/org-dashboard': [UserPermissionTypes.ORG_DASHBOARD_VIEW],
  '/transactions': [UserPermissionTypes.PAYMENT_ORDER_VIEW],
  '/payment-dropoffs': [UserPermissionTypes.PAYMENT_ORDER_VIEW],
  '/subscription-plan': [UserPermissionTypes.SUBSCRIPTION_VIEW],
  '/reports': [
    UserPermissionTypes.PAYMENT_ORDER_GENERATE_GST_REPORT,
    UserPermissionTypes.PAYMENT_ORDER_GENERATE_CUSTOM_REPORT
  ],
  '/customers-list': [UserPermissionTypes.CUSTOMER_LIST_VIEW],
  '/events': [UserPermissionTypes.EVENT_VIEW],
  '/events/create': [UserPermissionTypes.EVENT_CREATE],
  '/events/:eventId/attendee/:attendeeId': [
    UserPermissionTypes.EVENT_ATTENDEE_VIEW
  ],
  '/forms': [UserPermissionTypes.FORM_VIEW],
  '/forms/create': [UserPermissionTypes.FORM_CREATE],
  '/forms/success': [UserPermissionTypes.FORM_VIEW],
  '/forms/:formId/edit': [UserPermissionTypes.FORM_EDIT],
  '/forms/:formId/registrations': [UserPermissionTypes.FORM_SUBMISSION_VIEW],
  '/forms/:formId/drop-offs': [UserPermissionTypes.FORM_SUBMISSION_VIEW],
  '/forms/:formId/activity': [UserPermissionTypes.FORM_VIEW],
  '/forms/:formId': [UserPermissionTypes.FORM_VIEW],
  '/lead-management/reports': [UserPermissionTypes.LEAD_REPORT_GENERATE],
  '/branches/reports': [
    UserPermissionTypes.PAYMENT_ORDER_GENERATE_GST_REPORT,
    UserPermissionTypes.PAYMENT_ORDER_GENERATE_CUSTOM_REPORT,
    UserPermissionTypes.AUDIT_LOG_VIEW
  ]
};
